//Copyright Open Trade Technology Ltd. 2023. All rights reserved.
import React, { useEffect, useState } from 'react'
import { useAppKitAccount, useAppKitProvider, type Provider, useAppKitNetwork } from '@reown/appkit/react'
import { BrowserProvider, JsonRpcSigner } from 'ethers'
import { loginToChainFunction } from '@react/chainThunks/loginToChainThunk'
import { WalletEnum, RoleEnum } from '@shared/Enums'
import { useOtChainState, useOtDispatch, useOtSelector } from '@react/redux/store'
import { chainActions } from '@react/redux/chainSlice'
import { connectToChainThunk } from '@react/chainThunks/connectToChainThunk'
import { poolActions } from '@react/redux/poolSlice'
import { logOT } from '@shared/loggingShared'
import { Box, Modal, Paper, Typography, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { modalStyle } from './ButtonModal'
import CompanyProfileForm from '@react/admin/CompanyProfileForm'
import { CompanyProfileCTO } from '@shared/CompanyProfileCTO'
import { v4 as uuidv4 } from 'uuid'
import { getRequiredAddress } from '@shared/conversions'

let globalIsLoggingIn = false
export const AppKitListener = (): React.ReactNode => {
  const theme = useTheme()

  const { chainId, switchNetwork } = useAppKitNetwork()
  const {
    stageConfiguration: { chainConfigurations },
    chainConfiguration: { perimeterAddresses, chainId: currentChainId },
    userConnection: { accountAddr, companyProfile, signedMessage },
  } = useOtChainState()

  const chainState = useOtChainState()
  const poolOverviewCTOs = useOtSelector((state) => state.poolState.poolOverviewCTOs)

  const { isConnected, address, embeddedWalletInfo } = useAppKitAccount({ namespace: 'eip155' })
  const { walletProvider } = useAppKitProvider<Provider>('eip155')
  const dispatch = useOtDispatch()
  const [isLoggingIn, setIsLoggingIn] = useState(false)

  const [newCompanyProfile, setNewCompanyProfile] = useState<CompanyProfileCTO | undefined>(undefined)

  const [openModal, setOpenModal] = React.useState(false)

  // logOT.info('AppKitEthersSetupWrapper allAccounts', allAccounts)
  const {
    userConnection: { signer },
  } = useOtChainState()

  useEffect(() => {
    logOT.info('AppKitListener useEffect', address, accountAddr)
    if (walletProvider && address && accountAddr !== address) {
      const provider = new BrowserProvider(walletProvider, chainId)
      const signer = new JsonRpcSigner(provider, address)
      signer.getAddress().then((providerAddress) => {
        logOT.info(
          'AppKitListener accountAddr !== address',
          accountAddr,
          address,
          providerAddress,
          walletProvider,
          embeddedWalletInfo
        )
      })
    }
    if (address && accountAddr?.toLowerCase() !== address?.toLowerCase()) {
      logOT.info('AppKitListener accountAddr !== address', accountAddr, address)
      dispatch(chainActions.logoffUser())
    }
  }, [accountAddr, walletProvider, address])

  // useEffect(() => {
  //   if (roleEnum === RoleEnum.LENDER && location.hostname.startsWith('admin.')) {
  //     disconnect()
  //       .then(() => {
  //         console.log('Disconnected from AppKit')
  //         return dispatch(chainActions.logoffUser())
  //       })
  //       .catch((error) => {
  //         logOT.error('FOCUS: LogoutButton error', error)
  //       })
  //   }
  //   if ((roleEnum === RoleEnum.POOL_ADMIN || roleEnum == RoleEnum.BORROWER) && location.hostname.startsWith('app.')) {
  //     disconnect()
  //       .then(() => {
  //         console.log('Disconnected from AppKit')
  //         return dispatch(chainActions.logoffUser())
  //       })
  //       .catch((error) => {
  //         logOT.error('FOCUS: LogoutButton error', error)
  //       })
  //   }
  // }, [roleEnum])

  useEffect(() => {
    console.log(
      'AppKitListener setNewCompanyProfile',
      !companyProfile?.uuid,
      companyProfile?.uuid.length,
      'addr',
      accountAddr,
      signedMessage,
      location.hostname,
      'COMPLETE setOpenModal',
      (!companyProfile?.uuid || companyProfile.uuid.length == 0) &&
        accountAddr &&
        signedMessage &&
        location.hostname.startsWith('app')
    )
    if (
      (!companyProfile?.uuid || companyProfile.uuid.length == 0) &&
      accountAddr &&
      signedMessage &&
      location.hostname.startsWith('app')
    ) {
      setNewCompanyProfile({
        uuid: uuidv4(),
        companyName: '',
        emails: [],
        wallets: [accountAddr],
      })
      console.log('AppKitListener setNewCompanyProfile setOpenModal1 true')
      setOpenModal(true)
    }
  }, [companyProfile, accountAddr, signedMessage])
  // useEffect(() => {
  //   window.addEventListener(
  //     'modalClose',
  //     () => {
  //       console.log('AppKitListener setNewCompanyProfile setOpenModal2 false')
  //       setOpenModal(false)
  //     },
  //     false
  //   )

  //   return () => {
  //     window.removeEventListener(
  //       'modalClose',
  //       () => {
  //         console.log('AppKitListener setNewCompanyProfile setOpenModal3 false')
  //         setOpenModal(false)
  //       },
  //       false
  //     )
  //   }
  // }, [])
  useEffect(() => {
    if (signer) {
      console.log('AppKitListener setIsLoggingInfalse signer:')
      setIsLoggingIn(false)
    }
    if (signer && !walletProvider) {
      logOT.info('AppKitListener signer && !walletProvider', signer, walletProvider)
      dispatch(chainActions.logoffUser())
    }

    if (currentChainId !== chainId) {
      logOT.info('AppKitListener currentChainId !== chainId', currentChainId, chainId)
      const nextStageConfig = chainConfigurations.find((config) => config.chainId === chainId)
      const chainConfigurationName = nextStageConfig?.chainConfigurationName
      if (chainConfigurationName) {
        dispatch(chainActions.disconnectChainConfiguration())
        dispatch(poolActions.clearPoolState())
        dispatch(connectToChainThunk({ chainConfigurationName, switchNetwork }))
      }
    }
  }, [signer, walletProvider, chainId, currentChainId])

  useEffect(() => {
    const asyncFunct = async () => {
      console.log(
        'AppKitListener asyncFunct',
        !globalIsLoggingIn,
        !isLoggingIn,
        isConnected,
        !!walletProvider,
        address,
        !signer,
        !!perimeterAddresses
      )
      if (!isLoggingIn && isConnected && walletProvider && address && !signer && perimeterAddresses) {
        logOT.info('AppKitListener isLoggingIn', isLoggingIn)
        logOT.info('AppKitListener isLoggingIn SET  TRUE')

        const provider = new BrowserProvider(walletProvider, chainId)
        const signer = new JsonRpcSigner(provider, getRequiredAddress(address))
        logOT.info('AppKitListener send loginToChainThunk', signer)
        await loginToChainFunction(
          dispatch,
          poolOverviewCTOs,
          chainState,
          signer,
          WalletEnum.APP_KIT,
          RoleEnum.TO_BE_DETERMINED
        )

        logOT.info('AppKitListener loginToChainThunk done')
        logOT.info('AppKitListener isLoggingIn SET  FALSE2')
      }
    }
    if (
      !globalIsLoggingIn &&
      !isLoggingIn &&
      isConnected &&
      walletProvider &&
      address &&
      !signer &&
      perimeterAddresses
    ) {
      logOT.info('AppKitListener isLoggingIn SET  TRUE')
      setIsLoggingIn(true)
      globalIsLoggingIn = true
      asyncFunct()
        .then(() => {
          setIsLoggingIn(false)
          globalIsLoggingIn = false
        })
        .catch((error) => {
          console.error('AppKitListener asyncFunct error', error)
          setIsLoggingIn(false)
          globalIsLoggingIn = false
        })
    }
  }, [isLoggingIn, isConnected, walletProvider, address, signer, perimeterAddresses])
  const handleClose = (): void => {
    setOpenModal(false)
  }
  return (
    <>
      <Modal
        open={openModal}
        data-testid="modal"
        onClose={() => {
          console.log('AppKitListener setNewCompanyProfile setOpenModal4 false')
          setOpenModal(false)
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper sx={modalStyle}>
          <Typography
            align="left"
            sx={{ display: 'inline', float: 'left', fontWeight: 'bold', marginLeft: 4 }}
            variant={'h4'}
          >
            Register YourCompany Profile
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{ height: '14px', width: '14px', padding: 0, float: 'right', color: theme.palette.primary.main }}
          >
            <CloseIcon sx={{ width: '12px', height: '12px', marginTop: 0, color: theme.palette.fg.muted }} />
          </IconButton>
          <Box sx={{ marginTop: '32px', marginLeft: 2 }}>
            <CompanyProfileForm
              companyProfileCTO={newCompanyProfile}
              companyProfiles={[]}
              accountAddr={accountAddr}
              closeCallback={handleClose}
            />
          </Box>
        </Paper>
      </Modal>
    </>
  )
}
